﻿/**
 * portal-sidebar.controller
 * @namespace portal
 */

(function () {
	'use strict';

	/** get the angular module and add controller */
	angular.module('nha.portal').controller('portal-sidebar.controller', portalSidebarController);

	/** setup injection */
	portalSidebarController.$inject = ['appSettings', 'portal-quick-link.repository', 'portal-favorites.manager'];

	/** implementation */
	function portalSidebarController(appSettings, portalQuickLinkRepository, portalFavoritesManager) {
		/** pubic properties */
		var vm = this;
		vm.loading = false;
		vm.quickLinksVisible = true;
		vm.favoritesVisible = true;
		vm.quickLinks = [];
		vm.favorites = [];

		/** run init */
		init();

		/** private methods */

		/** initialize */
		function init() {
			/** flip loading flag */
			vm.loading = true;

			/** setup callbacks */
			portalFavoritesManager.addCallback('portal-favorites', setFavorites);

			/** get the quick links */
			portalQuickLinkRepository.getAll({ 'filter': { 'PortalLink/IsEnabled': true } }).then(function(quickLinks) {
				/** set quick links */
				vm.quickLinks = quickLinks;

				/** flip loading flag */
				vm.loading = false;
			});

		}

		/** callback for favorites */
		function setFavorites(favorites) {
			/** set the favorites */
			vm.favorites = favorites || [];
		}
	}
})();